import _ from 'lodash'

export const createErrorMessageSelector = (actions) => {
  return (state) => {
    return (
      _(actions)
        .map((action) => {
          return _.get(state, `api.error.${action}`)
        })
        .compact()
        .first() || ''
    )
  }
}

export const createLoadingSelector = (actions) => {
  return (state) => {
    return _(actions).some((action) => {
      return _.get(state, `api.loading.${action}`)
    })
  }
}

export const createSuccessSelector = (actions) => {
  return (state) => {
    return _(actions).some((action) => {
      return _.get(state, `api.success.${action}`)
    })
  }
}

export const createEndSelector = (actions) => {
  return (state) => {
    return _(actions).some((action) => {
      return _.get(state, `api.end.${action}`)
    })
  }
}
